import workerMeta from '@cofit/worker/package.json';
import appMeta from '../../package.json';
export var APP_NAME = appMeta.name;
export var APP_VERSION = appMeta.version;
export var APP_RELEASE_VERSION = process.env.NEXT_PUBLIC_RELEASE_VERSION;
export var SW_NAME = '@cofit/worker';
export var SW_VERSION = workerMeta.version;
export var ANALYSIS_GUIDE_VERSION = '1.1.0';